module.exports = __webpack_public_path__ + "static/media/map-marker-exclamation.6360e372.svg";